module.exports = __webpack_public_path__ + "static/media/pdf-not-found.effc610f.svg";